export default {
  business: 'For your business',
  'get-inspired': 'Get inspired',
  'how-to': 'How-to Guides',
  news: 'News',
  printstories: 'Printstories',
  highlights: 'Highlights',
  'business-growth': 'Business growth',
}
